import React, { useEffect, useState } from 'react'
import { extrasPorBono } from '../../../shared/helpers/api/apiCall';
import { Col, Row } from 'reactstrap';
import { Autocomplete, TextField } from '@mui/material';
import { formatCurrency } from '../../../shared/helpers/genericFunctions';

export const MontosBono = ({
    user,
    tipo,
    monto,
    setMonto,
    listaExtras,
    setListaExtras,
    selectExtras,
    setSelectExtras,
    cantidad,
    setCantidad
}) => {

    const [montoBono, setMontoBono] = useState(0);

    useEffect(() => {
        const params = `tipo_extra=${tipo.id}`;
        const fetchData = async () => {
            try {
                const response = await extrasPorBono('extras', user, params);
                const formattedData = response.data.map(item => ({
                    value: `${item.extra}`,
                    id: item.id,
                    monto: item.monto
                }));
                setListaExtras(formattedData);
            } catch (error) {
                console.error('error: ', error);
            }
        };

        fetchData();
    }, [setListaExtras]);

    const handleExtraSelect = (event, value) => {
        const selectedOption = listaExtras.find(option => option.value === value);
        if (selectedOption) {
            setSelectExtras({ id: selectedOption.id, value: selectedOption.value });
            setMonto(selectedOption.monto);
        } else {
            setSelectExtras({ id: '', value: '' });
            setMonto('');
        }
    }

    useEffect(() => {
        setMontoBono(monto * cantidad);
    }, [monto, cantidad])

    return (
        <>
            <Row>
                <Col>
                    <Autocomplete
                        className='mb-2'
                        id='conductores-select'
                        freeSolo
                        options={listaExtras.map((option) => option.value)}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                label={`Seleccionar ${tipo.value}`}
                                margin='normal'
                            />
                        }
                        onChange={handleExtraSelect}
                        value={selectExtras.value || ''}
                    />
                </Col>
                <Col>
                    <TextField
                        className='mb-2'
                        label="Cantidad"
                        value={cantidad}
                        onChange={(e) => setCantidad(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                    />
                </Col>
                <Col>
                    <TextField
                        className='mb-2'
                        label="Monto"
                        value={monto}
                        onChange={(e) => setMonto(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextField
                        className='mb-2'
                        label="Detalles"
                        value={selectExtras.details || ''}
                        onChange={(e) => setSelectExtras({ ...selectExtras, details: e.target.value })}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        required
                    />
                </Col>
            </Row>
            <Row>
                <h3>El monto del bono será de: { formatCurrency(montoBono) }</h3>
            </Row>
        </>
    )
}
